import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/layout/app-shell';
import { TrackerPage } from '@/pages/tracker/tracker-page';
import { HintsNotesPage } from '@/pages/tracker/hints-notes-page';
import { SongsPage } from '@/pages/tracker/songs-page';
import { EnemiesPage } from '@/pages/tracker/enemies-page';
import { SettingsPage } from '@/pages/tracker/settings-page';
import { TricksPage } from '@/pages/tricks/tricks-page';
import { EntrancesPage } from '@/pages/tracker/entrances-page';
import { LoginPage } from '@/pages/auth/login-page';

export function AppRouter() {
  return (
    <BrowserRouter>
      <AppShell>
        <Routes>
          <Route path="/" element={<Navigate to="/tracker" replace />} />
          <Route path="/tracker" element={<TrackerPage />} />
          <Route path="/tracker/notes" element={<HintsNotesPage />} />
          <Route path="/tracker/songs" element={<SongsPage />} />
          <Route path="/tracker/enemies" element={<EnemiesPage />} />
          <Route path="/tracker/entrances" element={<EntrancesPage />} />
          <Route path="/tracker/settings" element={<SettingsPage />} />
          <Route path="/tricks" element={<TricksPage />} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      </AppShell>
    </BrowserRouter>
  );
}
